import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./app/AppRoutes.tsx";
import { useThemeMode, ThemeModeProvider } from "./app/core/theme/themeContext.tsx";
import { muiLightTheme, muiDarkTheme } from "./app/shared/theme/muiTheme.ts";

const ThemedApp = () => {
  const { mode } = useThemeMode();
  return (
    <ThemeProvider theme={mode === "dark" ? muiDarkTheme : muiLightTheme}>
      <Router>
        <Routes />
      </Router>
    </ThemeProvider>
  );
};

function App() {
  return (
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  );
}

export default App;
